// extracted by mini-css-extract-plugin
export default {"container":"UserInfo_container__h11eT","avatar":"UserInfo_avatar__yl2xN","name":"UserInfo_name__LFv7a","email":"UserInfo_email__FBMnD"};